(function () {
  const parseScriptTag = ($script) => {
    try {
      return JSON.parse($script.innerHTML);
    } catch (error) {
      console.warn("Error Parsing Script Tag:", error);
      return undefined;
    }
  };

  function getBadgeData() {
    const $script = document.querySelector("script[data-product-badge-source]");

    return parseScriptTag($script);
  }

  function getProductData() {
    const productHandle = location.pathname.split("/").reverse()[0];
    return fetch(`/products/${productHandle}.js`).then((res) => res.json());
  }

  function generateBadgeHTML(title) {
    console.log("GenerateBadge:", title);
    return ` <span class="badge circle-divider circle-divider--narrow">${title}</span>`;
  }

  async function start() {
    const data = getBadgeData();
    const product = await getProductData();
    const $badgeContainer = document.querySelector(".price--badges");

    if (!$badgeContainer) return;

    const badge = data.find((badge) => {
      return product.tags.includes(badge.tag);
    });

    if (badge) {
      const html = generateBadgeHTML(badge.title);
      $badgeContainer.innerHTML += html;
    }
  }

  start();
})();
